import { createSelector } from 'reselect';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { showSelector } from 'selectors/testTarget/offers/updateQuickLookModal/show/showSelector';

const showUpdateQuickLookModalSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showUpdateQuickLookModalSelector };
